/** Human-readable label for Firestore `visibility.type`. */
export function formatDocumentVisibilityTypeLabel(type) {
  const t = typeof type === 'string' && type.trim() ? type.trim() : 'private';
  switch (t) {
    case 'public':
      return 'Public';
    case 'private':
      return 'Private';
    case 'roles':
      return 'By role';
    case 'users':
      return 'By user';
    case 'mixed':
      return 'Mixed';
    default:
      return t.charAt(0).toUpperCase() + t.slice(1);
  }
}

/** Tailwind classes for type pill (details modal). */
export function documentVisibilityTypePillClassName(type) {
  const t = typeof type === 'string' && type.trim() ? type.trim() : 'private';
  if (t === 'public') return 'bg-green-100 text-green-800';
  if (t === 'private') return 'bg-gray-100 text-gray-800';
  if (t === 'roles') return 'bg-amber-100 text-amber-900';
  if (t === 'users') return 'bg-indigo-100 text-indigo-800';
  if (t === 'mixed') return 'bg-violet-100 text-violet-800';
  return 'bg-slate-100 text-slate-800';
}

/** Compact badge for grid cards (text-xs). */
export function getDocumentVisibilityCardBadge(doc) {
  const t = doc?.visibility?.type || 'private';
  const base = 'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium';
  if (t === 'public') return { label: 'Public', className: `${base} bg-green-100 text-green-800` };
  if (t === 'private') return { label: 'Private', className: `${base} bg-gray-100 text-gray-700` };
  if (t === 'roles') return { label: 'By role', className: `${base} bg-amber-100 text-amber-900` };
  if (t === 'users')
    return { label: 'By user', className: `${base} bg-indigo-100 text-indigo-800` };
  if (t === 'mixed') return { label: 'Mixed', className: `${base} bg-violet-100 text-violet-800` };
  return {
    label: formatDocumentVisibilityTypeLabel(t),
    className: `${base} bg-slate-100 text-slate-700`,
  };
}

/** Compact badge for list rows. */
export function getDocumentVisibilityListBadge(doc) {
  const t = doc?.visibility?.type || 'private';
  const base = 'rounded-full px-2 py-0.5';
  if (t === 'public') return { label: 'Public', className: `${base} bg-green-50 text-green-700` };
  if (t === 'private') return { label: 'Private', className: `${base} bg-gray-100 text-gray-600` };
  if (t === 'roles') return { label: 'By role', className: `${base} bg-amber-50 text-amber-900` };
  if (t === 'users') return { label: 'By user', className: `${base} bg-indigo-50 text-indigo-800` };
  if (t === 'mixed') return { label: 'Mixed', className: `${base} bg-violet-50 text-violet-800` };
  return {
    label: formatDocumentVisibilityTypeLabel(t),
    className: `${base} bg-slate-50 text-slate-700`,
  };
}
